/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Button, Input, InputGroup } from 'reactstrap';
import PageHeader from '../../../components/pages/pageHeader';
import './styleAdicionais.css';
import moment from 'moment/moment';

import '../../eva/styleEva.css';

const RelatorioViagens = () => {
  const [dataInicial, setDataInicial] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dataFinal, setDataFinal] = useState(moment().format('YYYY-MM-DD'));

  const usuario = JSON.parse(sessionStorage.getItem('user'));

  const handleDateChange = (e, setter) => {
    const date = moment(e.target.value, 'YYYY-MM-DD');
    setter(date.isValid() ? date.format('YYYY-MM-DD') : e.target.value);
  };

  const handleBuscarClick = () => {
    if (!usuario || !usuario.id_cliente) {
      alert('Usuário não identificado. Por favor, faça login novamente.');
      return;
    }

    // Garantir que as datas estão no formato correto antes de enviar
    const startDate = moment(dataInicial).startOf('day').toISOString();
    const endDate = moment(dataFinal).endOf('day').toISOString();
    
    window.open(
      `https://axon-backend-service-194200739649.us-central1.run.app/report/viagens/${startDate}/${endDate}/${usuario.id_cliente}`,
      'RELATORIO',
      'location=no,width=800,height=600,top=10,left=10'
    );
  };

  return (
    <>
      <PageHeader
        title="Relatório de viagens"
        description=" "
        // eslint-disable-next-line react/no-children-prop
        children={
          <Row>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <InputGroup size="sm">
                <Input
                  type="date"
                  name="data_inicial"
                  value={dataInicial}
                  onChange={e => handleDateChange(e, setDataInicial)}
                  className="custom-input"
                />
                <Input
                  type="date"
                  name="data_final"
                  value={dataFinal}
                  onChange={e => handleDateChange(e, setDataFinal)}
                  className="custom-input"
                />
                <Button onClick={handleBuscarClick}>
                  Buscar
                </Button>
              </InputGroup>
            </Col>
          </Row>
        }
      />
    </>
  );
};

export default RelatorioViagens;